/**
 * Constants for Users page component
 */

export const ROLES = [
  { value: 'CH', label: 'Chairman (CH)' },
  { value: 'MP', label: 'Member Planning (MP)' },
  { value: 'ED', label: 'Executive Director (ED)' },
  { value: 'GM', label: 'General Manager (GM)' },
  // { value: 'NO', label: 'Nodal Officer (NO)' },
  { value: 'admin', label: 'System Administrator' },
];

export const REGIONS = [
  { value: 'ALL', label: 'All' },
  { value: 'NER', label: 'NER' },
  { value: 'NR', label: 'NR' },
  { value: 'WR', label: 'WR' },
  { value: 'SR', label: 'SR' },
  { value: 'ER', label: 'ER' },
];

export const ROLE_DESIGNATIONS = {
  CH: { designation: 'Chairman', escalationLevel: 5, region: 'ALL' },
  MP: { designation: 'Member Planning', escalationLevel: 4, region: 'ALL' },
  ED: { designation: 'Executive Director', escalationLevel: 3, region: '' },
  GM: { designation: 'General Manager', escalationLevel: 2, region: '' },
  // NO: { designation: 'Nodal Officer', escalationLevel: 1, region: '' },
  admin: { designation: 'System Administrator', escalationLevel: 5, region: 'ALL' },
};

export const INITIAL_FORM_DATA = {
  name: '',
  email: '',
  password: '',
  role: '',
  designation: '',
  whatsappNumber: '',
  region: '',
  canBeAssignee: true,
  canBeAssignor: true,
  escalationLevel: 1,
  isActive: true,
  projects: [],
};


export const getRegionConfig = (role) => {
  if (!role) {
    return {
      isVisible: false,
      isFixed: false,
      value: '',
      required: false,
      showOptions: false
    };
  }

  // CH, MP and admin: Auto-assign "ALL", fixed, no dropdown
  if (role === 'CH' || role === 'MP' || role === 'admin') {
    return {
      isVisible: true,
      isFixed: true,
      value: 'ALL',
      required: true,
      showOptions: false
    };
  }

  // ED and GM: Show dropdown, exclude "ALL" (handled by filter), manual selection
  if (role === 'ED' || role === 'GM') {
    return {
      isVisible: true,
      isFixed: false,
      value: '', // User must select
      required: true,
      showOptions: true
    };
  }

  return {
    isVisible: false,
    isFixed: false,
    value: '',
    required: false,
    showOptions: false
  };
};
